import './index.css';

const Overlay = ({ children, overlayClick }) => {
	return (
		<div className='Overlay' onClick={() => overlayClick()}>
			{children}
		</div>
	);
};

export default Overlay;
